import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const SuggestionImpressionsStoreExtension = ModuleExtensions.storeExtension({
  searchKey: undefined,
  reported: {}
}, 'suggestionImpressions', {
  useSearchKey: state => state.searchKey,
  useReported: state => state.reported
}, {
  markViewed: (_ref, _ref2) => {
    let draft = _ref.draft;
    let searchKey = _ref2.searchKey,
      key = _ref2.key;
    if (draft.searchKey !== searchKey) {
      draft.searchKey = searchKey;
      draft.reported = {};
    }
    draft.reported[key] = true;
  },
  resetState: _ref3 => {
    let draft = _ref3.draft;
    draft.searchKey = undefined;
    draft.reported = {};
  }
});
//# sourceMappingURL=suggestionImpressionsStore.js.map